export const expressApiKey = 'pk_live_PfCecLqPy7TXBDNUmrepjycY00s3cQvtgj';
export const standardApiKey = 'pk_live_VCOdhFenmteLZ7t9A0DJ334S';
export const baseUrl = 'https://api.myweavepay.com/';